<template>
  <div id="app">
    <Hosts />
  </div>
</template>

<script>
import Hosts from "./components/Hosts.vue";

export default {
  name: "app",
  components: {
    Hosts
  }
};
</script>

<style>
</style>
